import React, { useContext, useState, useEffect, useCallback, useRef } from "react";
import { Popover } from '@headlessui/react';

import { ArrowRightIcon, ArrowPathIcon, SparklesIcon } from "@heroicons/react/24/outline"
import { CheckCircleIcon } from "@heroicons/react/24/solid";

import { getLivelli } from "../services/api";
import { getSubscriptions, deleteSubscription } from '../services/api_subscriptions';

import { AuthContext } from "../contexts/auth"
import { whoami } from "../services/api"
import { calculateTotalCost as baseCalculateTotalCost, calculatePackageCost } from "../services/utils";

import Fetching from "../components/fetching";

import Swal from "sweetalert2"
import Footer from "../components/footer";
import SubscriptionManager from "../components/subscription_manager";
import ModalUpdateSubscription from "../components/subscription_update_modal";
import { Link } from "wouter";
import PopoverComponentCustom from "../components/popover_component";
import { TicketIcon } from "@heroicons/react/24/outline";
import CardMembershipOutlinedIcon from '@mui/icons-material/CardMembershipOutlined';
import XMarkIcon from '@heroicons/react/20/solid/XMarkIcon';
import FlareIcon from '@mui/icons-material/Flare';
import CustomTooltipComponent from "../components/custom_tooltip_component";
import LaunchIcon from '@mui/icons-material/Launch';

function getDurationFromNumber(months) {
    if(months == 12)
        return 'year';
    
    return 'month';
}


const calculatePackagePrice = (pkg) => {
    if (!pkg) return 0;

    // prezzo fisso
    if (!pkg.is_per_seat) {
        return Number(pkg.amount || 0);
    }

    // prezzo a scaglioni
    if (pkg.tiers?.length) {
        const { original } = baseCalculateTotalCost(
            employeeCount,
            pkg.tiers,
            profile.customer_type
        );

        return Number(original);
    }

    return 0;
};

export function Piano({duration, plan, isActive, style, handleSelectLevel, handleDeleteLevel, currentStatus, level, isLevelActive}) {
    return <>
        {duration == getDurationFromNumber(plan.duration_months) 
            && <>
            <h5 className="my-2 text-2xl font-bold tracking-tight text-gray-900 underline p-4">
                {
                    plan
                        .net_price
                        .toLocaleString(
                            'it-IT',
                            {style: 'currency', currency: 'EUR',}
                        )
                } + IVA
            </h5>
            <div className="mt-auto">
            { isLevelActive && !isActive && currentStatus != 'In prova' &&
                <div className="mb-3">
                    Il tuo piano risulta sottoscritto nella versione <span style={{ textDecoration: 'underline' }}>{duration === 'year' ? 'Mensile' : 'Annuale'}</span>
                </div>
                }
            {   
                !isActive ? (
                <button onClick={() => handleSelectLevel(level)} className="inline-flex items-center px-3 py-2 text-sm font-medium text-center text-white bg-blue-700 rounded-lg hover:bg-blue-800 focus:ring-4 focus:outline-none focus:ring-blue-300 dark:bg-blue-600 dark:hover:bg-blue-700 dark:focus:ring-blue-800">
                    Seleziona
                    <ArrowRightIcon className="h-5 w-5" />
                </button> ) : (
                <>
                    <p className="mb-3 font-normal text-gray-700 p-4 uppercase">
                        Stato: <span className={`${style.textColor} underline`}>{currentStatus}</span>
                    </p>
                    {/* #TODO: da migliorare condizione su button elimina*/}
                    {/* { currentStatus != 'Cancellato alla fine del periodo' && style.currentStatus !== 'In prova' ? (
                    <button onClick={() => handleDeleteLevel(level)} className="inline-flex items-center px-3 py-2 text-sm font-medium text-center text-white bg-red-700 rounded-lg hover:bg-red-800 focus:ring-4 focus:outline-none focus:ring-red-300 dark:bg-red-600 dark:hover:bg-red-700 dark:focus:ring-red-800">
                        Elimina
                        <TrashIcon className="h-5 w-5" />
                    </button>
                ) : null} */}
                </>
            )}
            </div>
            </>
        }
    </>;
};

export default function Livelli() {
    // TODO: si potrebbe spostare direttamente in nvabar?
    const { profile, token, setProfile } = useContext(AuthContext);
    const [levels, setLevels] = React.useState([]);
    const [customerPortal, setCustomerPortal] = useState();
    const [currentLevels, setCurrentLevels] = React.useState([]);
    const [duration, setDuration] = useState('month'); 
    const [loading, setLoading] = React.useState(false);
    const [employeeCount, setEmployeeCount] = useState(profile.employee_with_active_contracts ? profile.employee_with_active_contracts : 1);
    const [selectedBaseProducts, setSelectedBaseProducts] = useState([]);
    const [selectedProProducts, setSelectedProProducts] = useState([]);
    const durationToggleRef = React.useRef(null);
    const [isModalOpen, setIsModalOpen] = React.useState(false);
    const [selectedPlan, setSelectedPlan] = React.useState(null);
    const [couponCode, setCouponCode] = React.useState('');
    const [isLoading, setIsLoading] = React.useState(false);
    const [selectedPrice, setSelectedPrice] = useState(null);
    const [activeContractEmployees, setActiveContractEmployees] = useState();
    const [availableEmployees, setAvailableEmployees] = useState();
    const [activeSubscriptionCode, setActiveSubscriptionCode] = useState([]);
    const [showSubscriptionDetails, setShowSubscriptionDetails] = useState(false);
    const [subscriptions, setSubscriptions] = useState([]);
    const [error, setError] = useState(null);
    const [subscriptionTiers, setSubscriptionTiers] = useState({});
    const [isInTrial, setIsInTrial] = useState(false);
    const [mode, setMode] = useState('');
    const [subscriptionId, setSubscriptionId] = useState([]);
    const [selectedPlanUpgrade, setSelectedPlanUpgrade] = useState();
    const REOPEN_FLAG = "subscriptions:reopen";
    const [pending, setPending] = useState(0);
    const isFetching = pending > 0;
    const [packages, setPackages] = useState([]);
    const [selectedPackageIds, setSelectedPackageIds] = useState([]);
    const [selectedPackagesToCheckout, setSelectedPackagesToCheckout] = useState([]);
    const packagesSectionRef = useRef(null);

    // useEffect(() => {
    //     if (sessionStorage.getItem(REOPEN_FLAG) === "1") {
    //         setShowSubscriptionDetails(true);
    //         sessionStorage.removeItem(REOPEN_FLAG);
    //     }
    // }, []);


    const showError = (title, err, fallback) => {
        // messaggio “umano”
        const apiMsg =
            err?.response?.data
            ? Object.values(err.response.data).flat().join(", ")
            : err?.message;

        const msg = apiMsg || fallback;

        setError(msg);
        Swal.fire({ icon: "error", title, text: msg, confirmButtonText: "OK" });
    };

    const withPending = (fn, onError) => async (...args) => {
        setPending((p) => p + 1);
        try {
            return await fn(...args);
        } catch (e) {
            onError?.(e);
            // lascio rilanciare se vuoi bloccare Promise.all, altrimenti commenta la riga seguente
            // throw e;
        } finally {
            setPending((p) => p - 1);
        }
    };

    const isProfileComplete = profile.has_complete_profile;
    const isCompany = profile.customer_type === 'company';

    const nameTrans = {
        "pro year": "consultala_hr_pro_year",
        "pro month": "consultala_hr_pro_month",
        "base year": "consultala_hr_base_year",
        "base month": "consultala_hr_base_month",
    };

    const getTranslatedCodename = (planName) => nameTrans[`${planName.toLowerCase()} ${duration}`];

    const getTier = (planName) => {
        
        const planCodeName = getTranslatedCodename(planName);
        
        const level = levels.find(l => l.codename === planCodeName);
        return level?.tiers || [];
    };


    const durationLabel = {
        'month': 'Mensile',
        'year': 'Annuale',
    }

    const planDetails = {
        base: {
            month: { codename: "consultala_hr_base_month"},
            year: { codename: "consultala_hr_base_year"},
        },
        pro: {
            month: { codename: "consultala_hr_pro_month"},
            year: { codename: "consultala_hr_pro_year"},
        },
    };

    const featuresMapping = {
        base: {
            month: {
                'Visualizza Buste Paga e Documenti': true,
                'App Dipendente': true,
                'Portale Aziendale': true,
                'Portale Consulente': true,
                'Scadenzario Contratti e Documenti': true,
                'Gestione Presenze': false,
                'Gestione Turni': false,
                'Gestione Sedi': false,
                'Gestione Responsabile Sedi': false,
                'Autorizzazione Giustificativi': false,
                'Timbrature': false,
                'Avvisi Aziendali': false,
                'Esportazione Dati': false,
                'Rimborsi Spese e Km': false,
                'Generazione lettere e format personalizzati': false,
            },
            year: {
                'Visualizza Buste Paga e Documenti': true,
                'App Dipendente': true,
                'Portale Aziendale': true,
                'Portale Consulente': true,
                'Scadenzario Contratti e Documenti': true,
                'Gestione Presenze': false,
                'Gestione Turni': false,
                'Gestione Sedi': false,
                'Gestione Responsabile Sedi': false,
                'Autorizzazione Giustificativi': false,
                'Timbrature': false,
                'Avvisi Aziendali': false,
                'Esportazione Dati': false,
                'Rimborsi Spese e Km': false,
                'Generazione lettere e format personalizzati': false,
            },
        },
        pro: {
            month: {
                'Visualizza Buste Paga e Documenti': true,
                'App Dipendente': true,
                'Portale Aziendale': true,
                'Portale Consulente': true,
                'Scadenzario Contratti e Documenti': true,
                'Gestione Presenze': true,
                'Gestione Turni': true,
                'Gestione Sedi': true,
                'Gestione Responsabile Sedi': true,
                'Autorizzazione Giustificativi': true,
                'Timbrature': true,
                'Avvisi Aziendali': true,
                'Esportazione Dati': true,
                'Rimborsi Spese e Km': true,
                'Generazione lettere e format personalizzati': 'addon',
            },
            year: {
                'Visualizza Buste Paga e Documenti': true,
                'App Dipendente': true,
                'Portale Aziendale': true,
                'Portale Consulente': true,
                'Scadenzario Contratti e Documenti': true,
                'Gestione Presenze': true,
                'Gestione Turni': true,
                'Gestione Sedi': true,
                'Gestione Responsabile Sedi': true,
                'Timbrature': true,
                'Autorizzazione Giustificativi': true,
                'Avvisi Aziendali': true,
                'Esportazione Dati': true,
                'Rimborsi Spese e Km': true,
                'Generazione lettere e format personalizzati': 'addon',
            },
        },
    };

    const featureGuides = {
        'Visualizza Buste Paga e Documenti': 'https://consultalahr.com/cedolini-e-documenti/',
        'App Dipendente': 'https://consultalahr.com/applicazione-mobile/',
        // 'Portale Aziendale': true,
        // 'Portale Consulente': true,
        'Scadenzario Contratti e Documenti': 'https://consultalahr.com/scadenzario/',
        'Gestione Presenze': 'https://consultalahr.com/presenze/',
        'Gestione Turni': 'https://consultalahr.com/gestione-turni-hr/',
        // 'Gestione Sedi': false,
        // 'Gestione Responsabile Sedi': false,
        'Autorizzazione Giustificativi': 'https://consultalahr.com/giustificativi-dipendenti/',
        'Timbrature': 'https://consultalahr.com/timbrature/',
        'Avvisi Aziendali': 'https://consultalahr.com/feature-avvisi/',
        'Esportazione Dati': 'https://consultalahr.com/feature-esportazione-dati/',
        'Rimborsi Spese e Km': 'https://consultalahr.com/rimborsi-spese-dipendenti/',
        // 'Generazione lettere e format personalizzati': false,
    };

    const getStripePriceId = (codename) => levels.find(l => l.codename === codename)?.id;

    const getSubscriptionPlansByDuration = (duration) => {
        return Object.entries(planDetails).map(([planType, details]) => ({
            name: planType.charAt(0).toUpperCase() + planType.slice(1),
            codename: details[duration].codename,
            stripePlanId: getStripePriceId(details[duration].codename),
            features: featuresMapping[planType][duration],
        }));
    };
    
    const products = [
        { name: 'Timbrature', baseDisabled: true },
        { name: 'Scadenze contrattuali', baseDisabled: true },
        { name: 'Visite mediche', baseDisabled: false },
        { name: 'DPI', baseDisabled: false },
        { name: 'Missioni', baseDisabled: false },
    ];
      
    
    const handleDurationToggle = (newDuration) => {
        setDuration(newDuration);
    };

    const refreshProfileAndEmployees = useCallback(async () => {
        const updated = await whoami(token);
        setProfile(updated);
        setActiveContractEmployees(updated.employee_with_active_contracts);
        return updated;
    }, [token, setProfile]);

    const fetchLivelli = useCallback(async () => {
        const data = await getLivelli(token);
        setLevels(data.levels);
        setPackages(data.packages || []);
        setActiveSubscriptionCode(data.subscription);
        setCustomerPortal(data.customer_portal);
        setAvailableEmployees(data.available_employees);
        setIsInTrial(data.is_in_trial);
        return data; // <<< snapshot
    }, [token]);

    const getPackageBaseCode = (code) => {
        return (code || '').replace(/_(month|year)$/, '');
    };

    const ACTIVE_PACKAGE_STATUSES = ["active", "cancel_at_period_end"];

    const getActivePackage = (pkg) => {
        if (!pkg?.codename) return null;

        const packageBaseCode = getPackageBaseCode(pkg.codename);

        return (subscriptions || [])
            .flatMap((sub) => sub.packages || [])
            .find((activePkg) =>
                ACTIVE_PACKAGE_STATUSES.includes(activePkg?.status) &&
                getPackageBaseCode(activePkg?.plan?.code) === packageBaseCode
            );
    };

    const getPackageActiveLabel = (activePkg) => {
        const activeDuration = activePkg?.plan?.duration_months === 12 ? 'anno' : 'mese';
        return `Attivo ${activeDuration}`;
    };

    const hasActivePro = subscriptions?.some((sub) =>
        sub?.plan?.code?.includes("consultala_hr_pro")
    );

    const hasActiveBase = subscriptions?.some((sub) =>
        sub?.plan?.code?.includes("consultala_hr_base")
    );

    const activeProSubscription = subscriptions?.find((sub) =>
        sub?.plan?.code?.includes("consultala_hr_pro")
    );

    const activeBaseSubscription = subscriptions?.find((sub) =>
        sub?.plan?.code?.includes("consultala_hr_base")
    );

    const hasCancelAtPeriodEndSubscription = subscriptions?.some(
        (sub) => sub?.status === "cancel_at_period_end"
    );

    const handleAddPackageToExistingSubscription = (pkg) => {
        if (!pkg) return;

        setSelectedPlan(pkg);
        setSelectedPackagesToCheckout([pkg]);
        setSelectedPrice(getPackagePrice(pkg));
        setSelectedPlanUpgrade(pkg.id);
        setMode("addPackageToSubscription");
        setIsModalOpen(true);
    };

    const getPlanDurationFromCode = (code = "") => {
        if (code.endsWith("_year")) return "year";
        if (code.endsWith("_month")) return "month";
        return duration;
    };

    const getActivePackageBaseCodes = () => {
        return (activeProSubscription?.packages || [])
            .filter((pkg) => ACTIVE_PACKAGE_STATUSES.includes(pkg?.status))
            .map((pkg) => getPackageBaseCode(pkg?.plan?.code))
            .filter(Boolean);
    };

    const activeProDuration = activeProSubscription?.plan?.duration_months === 12 ? 'year' : 'month';

    const packagesByDuration = React.useMemo(() => {
        return (packages || []).filter((pkg) => pkg.duration === duration);
    }, [packages, duration]);

    const activePackageBaseCodes = React.useMemo(() => {
        return new Set(
            (subscriptions || [])
                .flatMap((sub) => sub.packages || [])
                .filter((pkg) => ACTIVE_PACKAGE_STATUSES.includes(pkg?.status))
                .map((pkg) => {
                    const code = pkg?.plan?.code || '';
                    return code.replace(/_(month|year)$/, '');
                })
                .filter(Boolean)
        );
    }, [subscriptions]);

    const getPackagePriceInfo = (pkg) =>
        calculatePackageCost(pkg, employeeCount, profile.customer_type);

    const getPackagePrice = (pkg) =>
        getPackagePriceInfo(pkg).amountCost;

    const getPackageRegularPrice = (pkg) => {
        const regularPrice =
            pkg?.meta?.regular_price ??
            pkg?.metadata?.regular_price ??
            pkg?.regular_price ??
            null;

        return regularPrice !== null && regularPrice !== undefined
            ? Number(regularPrice)
            : null;
    };

    const hasPackagePromo = (pkg) => {
        const regularPrice = getPackageRegularPrice(pkg);
        return regularPrice !== null && !Number.isNaN(regularPrice);
    };

    const togglePackage = (pkg) => {
        setSelectedPackageIds((prev) => {
            const exists = prev.includes(pkg.id);

            if (exists) {
                return prev.filter((id) => id !== pkg.id);
            }

            return [...prev, pkg.id];
        });
    };

    const isPackageActive = (pkg) => {
        if (!pkg?.codename) return false;

        const packageBaseCode = pkg.codename.replace(/_(month|year)$/, '');

        return activePackageBaseCodes.has(packageBaseCode);
    };

    const fetchSubscriptionsCompany = useCallback(async () => {
        const subs = await getSubscriptions(token);
        setSubscriptions(subs);
        return subs; // <<< snapshot
    }, [token]);

    const withPendingMemo = useCallback(
        (fn) => async (...args) => {
            setPending((p) => p + 1);
            try { return await fn(...args); }
            finally { setPending((p) => p - 1); }
        },
        []
    );

    const refreshBilling = useCallback(
        withPendingMemo(async () => {
            // livelli e subs possono andare in parallelo
            const [livelliData, subs] = await Promise.all([fetchLivelli(), fetchSubscriptionsCompany()]);

            // poi aggiorna profilo (può stare in parallelo, ma tenerlo qui rende chiaro l'ordine)
            await refreshProfileAndEmployees();

            // -- aggiorna derivati usando GLI SNAPSHOT appena ottenuti --
            const hasActiveSubscription = subs?.length > 0;
            const isTrial = livelliData?.is_in_trial;

            if (hasActiveSubscription) {
                setEmployeeCount(isTrial ? 1 : subs[0].quantity);
                setSubscriptionId(subs[0].id);
            } else {
                setEmployeeCount(1);
                setSubscriptionId(undefined);
            }

            setShowSubscriptionDetails(hasActiveSubscription && !isTrial);
            
            const tiersMap =
            subs?.reduce((acc, s) => {
                const level = (livelliData?.levels || []).find((l) => l.codename === s.plan.code);
                acc[s.id] = { name: s.plan.code, tiers: level?.tiers || [] };
                return acc;
            }, {}) || {};
            setSubscriptionTiers(tiersMap);
        }),
        [fetchLivelli, fetchSubscriptionsCompany, refreshProfileAndEmployees, withPendingMemo]
    );



    useEffect(() => {
        if (!token) return;

        setError(null);

        const runProfile = withPending(
            refreshProfileAndEmployees,
            (e) => showError("Errore profilo", e, "Impossibile aggiornare il profilo e i dipendenti attivi.")
        );

        const runLivelli = withPending(
            fetchLivelli,
            (e) => showError("Errore livelli", e, "Impossibile recuperare i livelli.")
        );

        const runSubs = withPending(
            fetchSubscriptionsCompany,
            (e) => showError("Errore sottoscrizioni", e, "Impossibile recuperare le sottoscrizioni.")
        );

        (async () => {
            // profilo in parallelo
            const profileP = runProfile();

            // livelli -> poi subs (dipendenza logica)
            const livelliData = await runLivelli();     // snapshot livelli + is_in_trial
            const subs = await runSubs();               // snapshot subscriptions

            // usa gli snapshot qui, NON lo state, così non crei dipendenze cicliche
            const hasActiveSubscription = subs?.length > 0;
            const isTrial = livelliData?.is_in_trial;

            if (hasActiveSubscription) {
                setEmployeeCount(isTrial ? 1 : subs[0].quantity);
                setSubscriptionId(subs[0].id);
            } else {
                setEmployeeCount(1);
                setSubscriptionId(undefined);
            }

            setShowSubscriptionDetails(hasActiveSubscription && !isTrial);

            const tiersMap = subs?.reduce((acc, s) => {
                const level = (livelliData?.levels || []).find(l => l.codename === s.plan.code);
                acc[s.id] = { name: s.plan.code, tiers: level?.tiers || [] };
                return acc;
            }, {}) || {};
            setSubscriptionTiers(tiersMap);

            await profileP; // aspetta anche profilo, se vuoi sincronizzare fine-caricamento
        })();
    }, [token, refreshProfileAndEmployees, fetchLivelli, fetchSubscriptionsCompany]);


    const handleSelectLevel = (plan, employeeCount) => {
        const codeName = getTranslatedCodename(plan.name);
        const selectedLevel = levels.find(level => level.codename === codeName);

        const isProPlan = plan.name === 'Pro';

        const validSelectedPackageIds = isProPlan ? selectedPackageIds : [];

        const selectedPackagesForPlan = packagesByDuration
            .filter((pkg) => validSelectedPackageIds.includes(pkg.id))
            .map((pkg) => pkg);

        const { discounted } = calculateTotalCost({
            ...plan,
            selectedPackageIds: validSelectedPackageIds,
        });

        if (!selectedLevel) {
            Swal.fire({
                icon: 'error',
                title: 'Nessun piano trovato',
                text: 'Nessun piano trovato per la durata selezionata. Contattaci',
                confirmButtonText: 'OK',
                allowOutsideClick: false,
            });
            return;
        }
        if (activeSubscriptionCode.length === 0) {
            if (employeeCount < activeContractEmployees) {
                Swal.fire({
                    icon: 'error',
                    title: 'Numero di licenze insufficiente',
                    html: `Hai <strong>${activeContractEmployees}</strong> contratti attivi.<br><br> Non è possibile acquistare un numero inferiore di licenze.`,
                    confirmButtonText: 'OK',
                    allowOutsideClick: false,
                });
                return;
            }
        }
        setSelectedPrice(discounted);
        setSelectedPlan(selectedLevel);
        setSelectedPlanUpgrade(undefined);

        setSelectedPackagesToCheckout(selectedPackagesForPlan);
                
        setCouponCode(couponCode);
        setIsModalOpen(true);
        setMode('newSubscription');
    };
    
    const handleUpgrade = (plan, availableEmployees) => {
        const codeName = getTranslatedCodename(plan.name);
        const selectedLevel = levels.find((level) => level.codename === codeName);

        if (!selectedLevel) {
            Swal.fire({
                icon: "error",
                title: "Nessun piano trovato",
                text: "Nessun piano trovato per la durata selezionata. Contattaci",
                confirmButtonText: "OK",
                allowOutsideClick: false,
            });
            return;
        }

        if (activeSubscriptionCode.length === 0 && employeeCount < activeContractEmployees) {
            Swal.fire({
                icon: "error",
                title: "Numero di licenze insufficiente",
                html: `Hai <strong>${activeContractEmployees}</strong> contratti attivi.<br><br> Non è possibile acquistare un numero inferiore di licenze.`,
                confirmButtonText: "OK",
                allowOutsideClick: false,
            });
            return;
        }

        const isProPlan = plan.name === "Pro";
        const validSelectedPackageIds = isProPlan ? selectedPackageIds : [];

        const targetDuration = getPlanDurationFromCode(selectedLevel.codename);

        const activePackageBaseCodes = getActivePackageBaseCodes();

        const packagesToUpdateDuration = isProPlan
            ? packages.filter((pkg) => {
                const pkgBaseCode = getPackageBaseCode(pkg.codename);

                return (
                    pkg.duration === targetDuration &&
                    activePackageBaseCodes.includes(pkgBaseCode)
                );
            })
            : [];

        const packagesAddedNow = isProPlan
            ? packages.filter((pkg) => validSelectedPackageIds.includes(pkg.id))
            : [];

        const selectedPackagesForPlan = [
            ...packagesToUpdateDuration,
            ...packagesAddedNow.filter(
                (pkg) => !packagesToUpdateDuration.some((p) => p.id === pkg.id)
            ),
        ];

        const { discounted } = calculateTotalCost({
            ...plan,
            selectedPackageIds: validSelectedPackageIds,
        });

        setEmployeeCount(availableEmployees);
        setSelectedPrice(discounted);
        setSelectedPlan(selectedLevel);
        setSelectedPlanUpgrade(selectedLevel.id);
        setSelectedPackagesToCheckout(selectedPackagesForPlan);
        setIsModalOpen(true);
        setMode("upgradeSubscription");
    };

    const showTimedLoader = async (seconds = 5, title = 'Aggiornamento in corso…') => {
        await Swal.fire({
            title,
            timer: seconds * 1000,
            timerProgressBar: true,
            allowOutsideClick: false,
            allowEscapeKey: false,
            showConfirmButton: false,
            didOpen: () => {
            Swal.showLoading();
            },
        });
    };
        
    const handleDeleteSubscription = async (subscriptionId) => {
        const subscription = subscriptions.find((sub) => sub.id === subscriptionId);

        const planCode = subscription?.plan?.code || '';
        const isPro = planCode.includes('consultala_hr_pro');
        const isBase = planCode.includes('consultala_hr_base');

        const planLabel = isPro ? 'HR Pro' : isBase ? 'HR Base' : 'piano';

        const activePackages = (subscription?.packages || []).filter(
            (pkg) => pkg?.status === 'active'
        );

        const hasActivePackages = activePackages.length > 0;

        const packageListHtml = activePackages
            .map((pkg) => `<li><strong>${pkg?.plan?.name || 'Pacchetto aggiuntivo'}</strong></li>`)
            .join('');

        const confirmation = await Swal.fire({
            title: `Conferma eliminazione piano`,
            html: `
                Stai eliminando il rinnovo automatico del piano <strong>${planLabel}</strong>.<br><br>
                Potrai continuare a utilizzare la piattaforma fino al periodo pagato.
                ${
                    hasActivePackages
                        ? `
                            <br><br>
                            <strong>Attenzione:</strong> eliminando il rinnovo del piano verranno eliminati anche i rinnovi dei pacchetti aggiuntivi attivi:
                            <ul style="text-align:center; margin-top:8px;">
                                ${packageListHtml}
                            </ul>
                        `
                        : ''
                }
                <br>
                Confermi l'eliminazione?
            `,
            icon: 'warning',
            showCancelButton: true,
            confirmButtonText: 'Conferma',
            cancelButtonText: 'Annulla',
        });

        if (!confirmation.isConfirmed) return;

        try {
            await deleteSubscription(token, subscriptionId);

            await showTimedLoader(5, 'Aggiornamento in corso...');

            await refreshBilling();

            await Swal.fire({
                icon: 'success',
                title: `Piano ${planLabel} eliminato`,
                text: 'La sottoscrizione è stata eliminata e i dati sono stati aggiornati.',
                confirmButtonText: 'OK',
            });

        } catch (error) {
            Swal.fire({
                title: 'Errore',
                text: 'Qualcosa è andato storto! Contattaci.',
                icon: 'error',
            });
        }
    };

    const handleDeletePackage = async (packageId) => {
        const confirmation = await Swal.fire({
            title: 'Conferma eliminazione pacchetto',
            text: "Stai per eliminare il pacchetto aggiuntivo: l’azione avrà effetto immediato. Eventuali crediti residui saranno riconosciuti nel prossimo rinnovo del piano attualmente in corso. Confermi l'eliminazione?",
            icon: 'warning',
            showCancelButton: true,
            confirmButtonText: 'Conferma',
            cancelButtonText: 'Annulla',
        });

        if (!confirmation.isConfirmed) return;

        try {
            await deleteSubscription(token, packageId);

            await showTimedLoader(5, 'Aggiornamento in corso...');

            await refreshBilling();

            await Swal.fire({
                icon: 'success',
                title: 'Pacchetto eliminato',
                text: 'Il pacchetto è stato eliminato e i dati sono stati aggiornati.',
                confirmButtonText: 'OK',
            });

        } catch (error) {
            Swal.fire({
                title: 'Errore',
                text: 'Qualcosa è andato storto! Contattaci.',
                icon: 'error',
            });
        }
    };

    const subscriptionKey = React.useMemo(
        () => subscriptions.map(s => `${s.id}:${s.status}:${s.quantity}`).join('|'),
        [subscriptions]
    );
    
    const handleOpenModal = (plan) => {
        setSelectedPlan(plan); 
        setIsModalOpen(true); 
    };

    const handleCloseModal = () => {
        setIsModalOpen(false);
        setSelectedPlan(null);
        setSelectedPackagesToCheckout([]);
        setSelectedPrice(null);
        setSelectedPlanUpgrade(undefined);
    };

    const handleBack = () => {
        setShowSubscriptionDetails(false);
        fetchSubscriptionsCompany();  
        refreshProfileAndEmployees();
        if (token) {
            fetchLivelli();
        } 
    };

    const handleEmployeeCountChange = (e) => {
        let value = parseInt(e.target.value, 10);
    
        if (isNaN(value)) {
            setEmployeeCount('');
            return;
        }
    
        if (value < 1) {
            setEmployeeCount(1);
        } else if (value > 500) {
            setEmployeeCount(500);
        } else {
            setEmployeeCount(value);
        }
    };

    const handleProductSelect = (productName, planName) => {
        if (planName === 'Base') {
            setSelectedBaseProducts((prevSelected) =>
                prevSelected.includes(productName)
                    ? prevSelected.filter((item) => item !== productName)
                    : [...prevSelected, productName]
            );
        } else if (planName === 'Pro') {
            setSelectedProProducts((prevSelected) =>
                prevSelected.includes(productName)
                    ? prevSelected.filter((item) => item !== productName)
                    : [...prevSelected, productName]
            );
        }
    };

    // const calculateTotalCost = (plan) => {
    //     const tiers = getTier(plan.name);
    //     return baseCalculateTotalCost(employeeCount, tiers, profile.customer_type)
    // };

    const calculateTotalCost = (plan) => {
        const tiers = getTier(plan.name);
        const isProPlan = plan.name === "Pro";

        const selectedPackages = isProPlan
            ? packagesByDuration.filter((pkg) => selectedPackageIds.includes(pkg.id))
            : [];

        const addonCost = selectedPackages.reduce(
            (acc, pkg) => acc + getPackagePrice(pkg),
            0
        );

        const addonRegularCost = selectedPackages.reduce(
            (acc, pkg) => acc + (getPackageRegularPrice(pkg) ?? getPackagePrice(pkg)),
            0
        );

        const result = baseCalculateTotalCost(
            employeeCount,
            tiers,
            profile.customer_type,
            addonCost,
            addonRegularCost
        );

        return {
            ...result,
            hasPackagePromoDiscount: addonRegularCost > addonCost,
        };
    };
    
    const handleShowSubscriptionDetails = () => {
        setShowSubscriptionDetails((prev) => !prev);
    }; 


    // const featureList = Object.keys(subscriptionPlans[0].features);

    const subscriptionPlansToRender = getSubscriptionPlansByDuration(duration);

    const hasActiveSubscription = subscriptions?.length > 0;
    const hasRealSubscription = hasActiveSubscription && !isInTrial;

    const activePackageCodes = React.useMemo(() => {
        return new Set(
            (subscriptions || [])
            .flatMap((sub) => sub.packages || [])
            .filter((pkg) => pkg?.status === "active")
            .map((pkg) => pkg?.plan?.code)
            .filter(Boolean)
        );
    }, [subscriptions]);

    const availablePackagesToAdd = React.useMemo(() => {
        const targetDuration = hasActivePro ? activeProDuration : duration;

        return (packages || []).filter((pkg) => {
            if (!pkg?.codename) return false;
            if (pkg.duration !== targetDuration) return false;

            return !activePackageBaseCodes.has(getPackageBaseCode(pkg.codename));
        });
    }, [packages, duration, hasActivePro, activeProDuration, activePackageBaseCodes]);

    const hasPackagesToAdd = (hasActivePro && availablePackagesToAdd.length > 0) || (hasActiveBase && availablePackagesToAdd.length > 0);

    const handleShowPackages = () => {
        setShowSubscriptionDetails(false);

        setTimeout(() => {
            packagesSectionRef.current?.scrollIntoView({
            behavior: "smooth",
            block: "center",
            });
        }, 100);
    };

    if (isFetching) return <Fetching />;

    // TODO: move template to single file
    return (

        <>
            <PopoverComponentCustom title="Abbonamenti" />
            {error && (
                <div className="mx-auto max-w-7xl px-4 py-2 mb-4 rounded-md bg-red-50 text-red-700 border border-red-200 text-sm">
                    {error}
                </div>
            )}
            {isCompany && !isProfileComplete && profile?.company?.email == profile?.the_real_user_email && (
                <div className="w-full">
                    <div className="bg-orange-100 text-orange-600 p-4 mb-6">
                        <p className="text-center text-sm font-semibold">
                        Il profilo non è completo. <br />
                        Per abilitare l'acquisto di un piano, compila i campi mancanti{' '}
                        <Link
                            to="/profilo/fatturazione"
                            className="text-indigo-600 hover:text-indigo-800 underline"
                        >
                            cliccando qui
                        </Link>
                        </p>
                    </div>
                </div>
            )}

            <div style={{ display: 'flex', flexDirection: 'column', minHeight: '100vh' }}>
                {/*── CARD ABBONAMENTO – versione ‘cute’ ─────────────────────*/}
                {profile.can_purchase && (
                    <div className="mx-auto mt-6 w-full max-w-7xl px-4 sm:px-6 lg:px-8">
                        <div
                            className="
                                relative overflow-hidden rounded-3xl p-6
                                [background:rgba(255,255,255,0.55)] backdrop-blur
                                border border-transparent
                                before:absolute before:inset-0 before:-z-10
                                before:[background:conic-gradient(var(--tw-gradient-stops))]
                                before:from-indigo-400 before:via-sky-400 before:to-purple-400
                                before:opacity-40
                                before:rounded-[inherit] before:p-[1px] before:mask
                                before:[mask:linear-gradient(#000_0_0)#fff_0_0,#000_0_0)]"
                        >
                            {/* Header */}
                            <div className="flex flex-col gap-4 md:flex-row md:items-center md:justify-between">
                                <h2 className="flex items-center gap-2 text-lg font-semibold text-indigo-800">
                                    <CardMembershipOutlinedIcon className="h-4 w-4" />
                                    Gestisci il tuo abbonamento
                                </h2>

                                <button
                                onClick={handleShowSubscriptionDetails}
                                className="
                                    group inline-flex items-center gap-2 rounded-full
                                    bg-indigo-600/90 px-4 py-2 text-sm font-bold text-white shadow-lg
                                    transition-transform duration-200 hover:scale-105 hover:bg-indigo-600
                                "
                                >
                                    {showSubscriptionDetails ? (
                                        <>
                                            {hasRealSubscription ? (
                                                <>
                                                    <ArrowPathIcon className="h-4 w-4" />
                                                    Aggiorna piano sottoscritto
                                                </>
                                            ) : (
                                                <>
                                                    <XMarkIcon className="h-4 w-4" />
                                                    Chiudi sottoscrizioni attive
                                                </>
                                            )}
                                        </>
                                    ) : (
                                        <>
                                            <TicketIcon className="h-4 w-4" />
                                            {hasRealSubscription ? 'Dettaglio piano sottoscritto' : 'Sottoscrizioni attive'}
                                        </>
                                    )}
                                </button>
                            </div>

                            {/* Licenze  */}
                            <div className="mt-4 flex flex-wrap items-center gap-2 text-md text-gray-700">
                                <span>Licenze utilizzate</span>

                                <span className="inline-flex items-center gap-1 rounded-full bg-gray-800/10 px-2 py-0.5 font-semibold text-indigo-800 text-center">
                                    {activeContractEmployees}
                                </span>

                                <span className="text-gray-500">su</span>

                                <span className="inline-flex items-center gap-1 rounded-full bg-gray-800/10 px-2 py-0.5 font-semibold text-indigo-800">
                                    {availableEmployees || 0}
                                </span>

                                <span className="text-gray-500">disponibili</span>
                            </div>
                        </div>
                    </div>
                )}

                {profile?.can_purchase && showSubscriptionDetails && (
                    <div className="flex-grow h-full">
                        {hasPackagesToAdd && (
                            <div className="mx-auto mt-6 w-full max-w-7xl px-4 sm:px-6 lg:px-8">
                                {(hasActivePro || hasActiveBase) && (
                                    <div
                                        className="
                                            relative overflow-hidden rounded-3xl p-5
                                            bg-white/60 backdrop-blur
                                            border border-indigo-100 shadow-sm
                                            before:absolute before:inset-0 before:-z-10
                                            before:bg-gradient-to-r before:from-indigo-300 before:via-sky-300 before:to-purple-300
                                            before:opacity-30
                                        "
                                    >
                                        <div className="flex flex-col gap-4 md:flex-row md:items-center md:justify-between">
                                            <div className="flex items-start gap-4">
                                                <div className="flex h-11 w-11 shrink-0 items-center justify-center rounded-2xl bg-indigo-100 text-indigo-700 shadow-sm">
                                                    <SparklesIcon className="h-6 w-6" />
                                                </div>

                                                <div>
                                                    {hasActivePro ? (
                                                        <>
                                                            <p className="text-xs font-bold uppercase tracking-[0.18em] text-indigo-600">
                                                                Nuovi pacchetti disponibili
                                                            </p>

                                                            <h3 className="mt-1 text-lg font-semibold text-indigo-900">
                                                                Aggiungi nuove funzionalità al tuo piano
                                                            </h3>

                                                            <p className="mt-1 max-w-3xl text-sm leading-6 text-gray-600">
                                                                Puoi aggiungere alla sottoscrizione in corso i seguenti pacchetti:
                                                            </p>
                                                        </>
                                                    ) : (
                                                            <>
                                                                <p className="text-xs font-bold uppercase tracking-[0.18em] text-indigo-600">
                                                                    Nuovi pacchetti disponibili con il piano HR pro
                                                                </p>
                                                                <h3 className="mt-1 text-lg font-semibold text-indigo-900">
                                                                    Sottoscrivendo il piano HR Pro puoi aggiungere i seguenti pacchetti:
                                                                </h3>
                                                            </>
                                                    )}

                                                    <div className="mt-2 flex flex-wrap gap-2">
                                                        {availablePackagesToAdd.map((pkg) => (
                                                            <span
                                                                key={pkg.id}
                                                                className="inline-flex rounded-full bg-white px-3 py-1 text-xs font-semibold text-indigo-700 border border-indigo-200"
                                                            >
                                                                {pkg.name}
                                                            </span>
                                                        ))}
                                                    </div>
                                                </div>
                                            </div>

                                            <button
                                                type="button"
                                                onClick={handleShowPackages}
                                                className="
                                                    group inline-flex items-center justify-center gap-2 rounded-full
                                                    bg-indigo-600/90 px-4 py-2 text-sm font-bold text-white shadow-lg
                                                    transition-transform duration-200 hover:scale-105 hover:bg-indigo-600
                                                    whitespace-nowrap
                                                "
                                            >
                                                Vedi pacchetti
                                                <ArrowRightIcon className="h-4 w-4 transition-transform group-hover:translate-x-0.5" />
                                            </button>
                                        </div>
                                    </div>
                                )}
                            </div>
                        )}

                        <SubscriptionManager
                            key={subscriptionKey}    
                            token={token} 
                            customerPortal={customerPortal} 
                            onBack={handleBack}
                            activeSubscriptionCode={activeSubscriptionCode}
                            activeEmployeesNumber={activeContractEmployees}
                            availableEmployees={availableEmployees}
                            subscriptionDetails={subscriptions}
                            onDelete={handleDeleteSubscription}
                            onDeletePackage={handleDeletePackage}
                            onUpdateSubscription={handleOpenModal}
                            customerType={profile.customer_type}
                            tiers={subscriptionTiers}
                            onSubscriptionChanged={refreshBilling}
                        />
                    </div>
                )}

               {(!profile?.can_purchase || !showSubscriptionDetails) && (
                    <div className="bg-white pb-8 pt-0">
                        <div className="mx-auto max-w-7xl px-6 lg:px-8">
                            {(!profile?.can_purchase) ? (
                                <div className="pt-8 min-h-screen">
                                    {profile.the_real_user_email === profile.company.email ? (
                                        <div className="bg-gray-50 p-12 rounded-md shadow-md text-center">
            
                                            <p className="mx-auto w-1/2 text-center mb-5 font-bold underline">
                                                L'attuale piano di abbonamento non è gestito da te
                                            </p>
                                            <p className="mx-auto w-2/3 text-center mb-4">
                                                Se desideri iniziare a gestire in autonomia il tuo piano di abbonamento chiedi al tuo consulente di <span className="font-bold text-purple-500">scollegare l'azienda</span> tramite l'apposita funzione. 
                                            </p>
                                            <p className="mx-auto w-2/3 text-center">
                                                In caso necessiti di supporto scrivici a:  
                                            </p>
                                            <p className="mx-auto w-1/2 text-center underline italic">
                                                <a href="mailto:supporto@consultala.com" className="text-purple-600 hover:underline">supporto@consultala.com</a>
                                            </p>
                                        </div>
                                    ) : (
                                        <div className="bg-gray-50 p-12 rounded-md shadow-md text-center">
            
                                            <p className="mx-auto w-1/2 text-center mb-5 font-bold underline">
                                                L'attuale piano di abbonamento non è gestito da te
                                            </p>
                                            <p className="mx-auto w-1/2 text-center mb-10">
                                                Se desideri iniziare a gestire in autonomia il tuo piano di abbonamento o apportare modifiche alla configurazione attuale, contattaci via email al seguente indirizzo:
                                            </p>
                                            <p className="mx-auto w-1/2 text-center underline italic">
                                                <a href="mailto:supporto@consultala.com" className="text-purple-600 hover:underline">supporto@consultala.com</a>
                                            </p>
                                        </div>
                                    )}
                                </div>
                            ) : (
                                <main className="mt-6 pb-8">
                                    <p className="mx-auto max-w-2xl text-center text-md font-medium text-gray-900 pb-6">
                                        Seleziona il piano per la tua azienda e scopri tutte le funzionalità disponibili
                                    </p>
                                    <div className="flex justify-center w-full">
                                        <div className="relative inline-flex items-center w-full shadow-lg">
                                            <button
                                                onClick={() => handleDurationToggle('month')}
                                                className={`flex-1 p-2 text-center rounded-l-md transition-colors ${
                                                    duration === 'month' ? 'bg-indigo-200 text-indigo-800 font-bold' : 'bg-white text-indigo-800 border border-gray-100'
                                                }`}
                                            >
                                                {durationLabel.month}
                                            </button>
                                            <button
                                                onClick={() => handleDurationToggle('year')}
                                                className={`flex-1 p-2 text-center rounded-r-md transition-colors ${
                                                    duration === 'year' ? 'bg-indigo-200 text-indigo-800 font-bold' : 'bg-white text-indigo-800 border border-gray-100'
                                                }`}
                                            >
                                                {durationLabel.year}
                                            </button>
                                        </div>
                                    </div>
                                    <div className="mt-6 overflow-visible relative">
                                        <div className="table w-full">

                                            {/* Tabella dei Piani di abbonamento */}
                                            <table className="w-full table-fixed border-collapse shadow-md">
                                                <thead>
                                                    <tr>
                                                        <th className="w-1/3 text-left text-lg font-semibold text-gray-900"></th>
                                                        {subscriptionPlansToRender.map((plan) => (
                                                            <th
                                                                key={plan.name}
                                                                className={`relative px-4 py-6 text-center text-2xl text-indigo-800 font-bold rounded-t-lg ${
                                                                    plan.name === 'Pro'
                                                                        ? 'bg-indigo-100 border-b border-indigo-300 shadow-lg'
                                                                        : 'bg-gray-50 border-gray-200 rounded-t-lg'
                                                                }`}
                                                            >
                                                                {profile.customer_type === 'consultant' && (
                                                                    <div className="text-sm mb-2 border border-orange-500 text-orange-500 py-1 rounded-2xl bg-orange-50 w-2/3 flex justify-center items-center mx-auto text-center">
                                                                        Promo Consulente -30%
                                                                    </div>
                                                                )}
                                                                Piano {plan.name}
                                                            </th>
                                                        ))}
                                                    </tr>
                                                </thead>
                                    
                                                <tbody className="divide-y divide-gray-200 border border-gray-200 rounded-md">
                                                    {Object.keys(subscriptionPlansToRender[0].features).map((feature) => {
                                                        const isAddonRow = subscriptionPlansToRender.some(
                                                            (plan) => plan.features[feature] === 'addon'
                                                        );

                                                        const hasAddonPromo = isAddonRow && packagesByDuration.some((pkg) => {
                                                            const regularPrice = getPackageRegularPrice(pkg);
                                                            const price = getPackagePrice(pkg);

                                                            return regularPrice !== null && regularPrice > price;
                                                        });

                                                        if (isAddonRow) {
                                                            return (
                                                                <React.Fragment key={feature}>
                                                                    {/* intestazione sezione pacchetti */}
                                                                    <tr ref={packagesSectionRef}>
                                                                        <td
                                                                            colSpan={subscriptionPlansToRender.length + 1}
                                                                            className="bg-indigo-50 px-4 py-2 text-center text-xs font-bold uppercase tracking-wide text-indigo-700"
                                                                        >
                                                                            Pacchetti aggiuntivi
                                                                        </td>
                                                                    </tr>

                                                                    {/* UNA RIGA PER OGNI PACCHETTO */}
                                                                    {packagesByDuration.map((pkg) => {
                                                                        const activePkg = getActivePackage(pkg);
                                                                        const active = Boolean(activePkg);
                                                                        const selected = selectedPackageIds.includes(pkg.id);

                                                                        const price = getPackagePrice(pkg);
                                                                        const regularPrice = getPackageRegularPrice(pkg);
                                                                        const hasPromo = hasPackagePromo(pkg);

                                                                        const packageDurationMismatch = hasActivePro && pkg.duration !== activeProDuration;

                                                                        return (
                                                                            <tr key={pkg.id}>
                                                                                {/* NOME PACCHETTO */}
                                                                                <td className="px-4 py-3 text-left text-sm font-medium text-gray-900">
                                                                                    <div
                                                                                        className={`flex flex-col justify-between h-full ${
                                                                                            hasPromo ? "min-h-[140px]" : ""
                                                                                        }`}
                                                                                    >
                                                                                        {hasPromo && (
                                                                                            <div className="inline-flex items-center text-[12px] font-bold border border-orange-500 text-orange-500 py-0.5 px-4 rounded-2xl bg-orange-50 w-fit">
                                                                                                <FlareIcon sx={{ fontSize: '14px' }} className="me-2" />
                                                                                                PROMO LANCIO
                                                                                            </div>
                                                                                        )}

                                                                                        <div className="mt-2">
                                                                                            <span className="font-semibold">
                                                                                                {pkg.name}
                                                                                            </span>

                                                                                            {pkg.description?.trim() && (
                                                                                                <p className="mt-1 text-xs font-normal leading-relaxed text-gray-500 whitespace-normal break-words">
                                                                                                    {pkg.description}
                                                                                                </p>
                                                                                            )}
                                                                                        </div>

                                                                                        {hasPromo && (
                                                                                            <div className="text-xs text-gray-500 leading-relaxed max-w-md">
                                                                                                Prezzo bloccato per sempre. Promo disponibile solo per un periodo limitato.
                                                                                            </div>
                                                                                        )}
                                                                                    </div>
                                                                                </td>

                                                                                {/* COLONNE DEI PIANI */}
                                                                                {subscriptionPlansToRender.map((plan) => (
                                                                                    <td
                                                                                        key={plan.codename}
                                                                                        className={`text-center px-4 py-3 border ${
                                                                                            plan.features[feature] === "addon"
                                                                                                ? "text-indigo-600 border-gray-200 bg-gray-50"
                                                                                                : "text-gray-400 border-gray-200"
                                                                                        }`}
                                                                                    >
                                                                                        {plan.features[feature] === "addon" ? (
                                                                                            <div className="mx-auto w-full rounded-xl border border-indigo-200 bg-white p-3 shadow-sm">
                                                                                                <div className="px-3 py-2 rounded-xl border border-indigo-100 bg-indigo-50/40 text-center">
                                                                                                    {hasPromo && regularPrice !== null && (
                                                                                                        <div className="flex items-center justify-center gap-2">
                                                                                                            <span className="text-md text-gray-500 font-semibold line-through">
                                                                                                                € {Number(regularPrice).toFixed(2)} /{" "}
                                                                                                                {pkg.duration === "year"
                                                                                                                    ? "anno"
                                                                                                                    : "mese"}{" "}
                                                                                                                + IVA
                                                                                                            </span>
                                                                                                        </div>
                                                                                                    )}

                                                                                                    <div className="mt-1 text-md font-semibold text-indigo-700">
                                                                                                        {hasPromo && (
                                                                                                            <span className="rounded-full bg-orange-100 px-2 py-0.5 text-[10px] font-bold text-orange-600 me-2">
                                                                                                                PROMO
                                                                                                            </span>
                                                                                                        )}

                                                                                                        € {Number(price).toFixed(2)}
                                                                                                        <span className="ml-1 text-md font-semibold text-indigo-700">
                                                                                                            /{" "}{pkg.duration === "year" ? "anno" : "mese"}{" "} + IVA
                                                                                                        </span>
                                                                                                    </div>

                                                                                                    {pkg.is_per_seat && (
                                                                                                        <div className="mt-1 text-[11px] text-indigo-500">
                                                                                                            calcolato su{" "}
                                                                                                            {Number(employeeCount || 1)}{" "}
                                                                                                            dipendenti
                                                                                                        </div>
                                                                                                    )}
                                                                                                </div>

                                                                                                {active ? (
                                                                                                    <span className="mt-2 inline-flex rounded-full bg-green-100 px-3 py-1 text-xs font-semibold text-green-700">
                                                                                                        {getPackageActiveLabel(activePkg)}
                                                                                                    </span>
                                                                                                ) : hasActivePro ? (
                                                                                                    <CustomTooltipComponent
                                                                                                        title={
                                                                                                            hasCancelAtPeriodEndSubscription
                                                                                                                ? "Non puoi aggiungere pacchetti perché il rinnovo automatico della sottoscrizione è stato disattivato"
                                                                                                                : packageDurationMismatch
                                                                                                                ? `Disponibile con piano Pro ${pkg.duration === "year" ? "Annuale" : "Mensile"}`
                                                                                                                : ""
                                                                                                        }
                                                                                                        arrow
                                                                                                        placement="top"
                                                                                                    >
                                                                                                        <span className="block">
                                                                                                            <button
                                                                                                                type="button"
                                                                                                                onClick={() => handleAddPackageToExistingSubscription(pkg)}
                                                                                                                disabled={packageDurationMismatch || hasCancelAtPeriodEndSubscription}
                                                                                                                className={`mt-2 w-full rounded-lg px-3 py-1.5 text-xs font-semibold ${
                                                                                                                    packageDurationMismatch || hasCancelAtPeriodEndSubscription
                                                                                                                        ? "cursor-not-allowed bg-gray-300 text-gray-500"
                                                                                                                        : "bg-indigo-600 text-white hover:bg-indigo-500"
                                                                                                                }`}
                                                                                                            >
                                                                                                                {hasCancelAtPeriodEndSubscription
                                                                                                                    ? "Non disponibile"
                                                                                                                    : packageDurationMismatch
                                                                                                                    ? `Disponibile con piano Pro ${pkg.duration === "year" ? "Annuale" : "Mensile"}`
                                                                                                                    : "Aggiungi al piano"}
                                                                                                            </button>
                                                                                                        </span>
                                                                                                    </CustomTooltipComponent>
                                                                                                ) : (
                                                                                                    <>
                                                                                                        <button
                                                                                                            type="button"
                                                                                                            onClick={() => togglePackage(pkg)}
                                                                                                            className={`mt-2 w-full rounded-lg px-3 py-1.5 text-xs font-semibold transition ${
                                                                                                                selected
                                                                                                                    ? "bg-green-100 text-green-700 hover:bg-green-200"
                                                                                                                    : "bg-indigo-600 text-white hover:bg-indigo-500"
                                                                                                            }`}
                                                                                                        >
                                                                                                            {selected ? "Aggiunto al piano" : "Aggiungi al piano"}
                                                                                                        </button>

                                                                                                        {selected && !hasActivePro && hasActiveBase && (
                                                                                                                <p className="text-[10px] font-semibold text-indigo-500 uppercase tracking-tight leading-none pt-2">
                                                                                                                    Procedi con "Aggiorna Sottoscrizione" per finalizzare l'acquisto del Piano Pro + Pacchetto
                                                                                                                </p>
                                                                                                            )}

                                                                                                        {selected && !hasActivePro && !hasActiveBase && (
                                                                                                                <p className="text-[10px] font-semibold text-indigo-500 uppercase tracking-tight leading-none pt-2">
                                                                                                                    Procedi con "Scegli" per finalizzare l'acquisto del Piano Pro + Pacchetto
                                                                                                                </p>
                                                                                                            )}
                                                                                                    </>
                                                                                                )}
                                                                                            </div>
                                                                                        ) : (
                                                                                            "✗"
                                                                                        )}
                                                                                    </td>
                                                                                ))}
                                                                            </tr>
                                                                        );
                                                                    })}
                                                                </React.Fragment>
                                                            );
                                                        }

                                                        // FEATURE NORMALI
                                                        return (
                                                            <tr key={feature}>
                                                                <td className="px-4 py-3 text-left text-sm font-medium text-gray-900">
                                                                    {featureGuides[feature] ? (
                                                                        <a
                                                                            href={featureGuides[feature]}
                                                                            target="_blank"
                                                                            rel="noopener noreferrer"
                                                                            className="group inline-flex items-center text-gray-900"
                                                                        >
                                                                            <span className="transition-all duration-200 underline decoration-indigo-600 [text-underline-offset:3px]">
                                                                                {feature}
                                                                            </span>

                                                                            <LaunchIcon
                                                                                sx={{ fontSize: 16, marginLeft: 1 }}
                                                                                className="opacity-100 transition-opacity duration-200 text-indigo-600"
                                                                            />
                                                                        </a>
                                                                    ) : (
                                                                        <span>{feature}</span>
                                                                    )}
                                                                </td>

                                                                {subscriptionPlansToRender.map((plan) => (
                                                                    <td
                                                                        key={plan.codename}
                                                                        className={`text-center px-4 py-3 border ${
                                                                            plan.features[feature]
                                                                                ? "text-indigo-600 border-gray-200 bg-gray-50"
                                                                                : "text-gray-400 border-gray-200"
                                                                        }`}
                                                                    >
                                                                        {plan.features[feature] ? (
                                                                            <CheckCircleIcon className="inline-block h-5 w-5" />
                                                                        ) : (
                                                                            "✗"
                                                                        )}
                                                                    </td>
                                                                ))}
                                                            </tr>
                                                        );
                                                    })}
                                                </tbody>
                                            </table>

                                            {/* Tabella per il calcolo del costo */}
                                            <table className="w-full table-fixed border-collapse shadow-md mt-4">
                                                <thead>
                                                    <tr>
                                                        <th colSpan={3} className="bg-indigo-100 mx-auto max-w-2xl text-center text-xl font-semibold text-indigo-800 py-3 rounded-t-md">
                                                            Calcola il costo e scegli il tuo piano
                                                        </th>
                                                    </tr>
                                                </thead>
                                                <tbody className="divide-y divide-gray-200 border border-gray-200 rounded-md">
                                                    <tr>
                                                        <td className="px-4 py-4 text-left text-sm font-medium text-gray-900 border border-gray-200 text-indigo-800 font-semibold">
                                                            {profile?.employee_with_active_contracts > 0 && (
                                                                <div>Il numero attuale di dipendenti attivi è {profile?.employee_with_active_contracts}</div>
                                                            )}
                                                            <input
                                                                type="number"
                                                                min={1}
                                                                max="500"
                                                                step="1"
                                                                value={employeeCount}
                                                                onChange={handleEmployeeCountChange}
                                                                className="rounded-md border-gray-200 w-full mt-3 focus:border-indigo-800 focus:ring-indigo-800"
                                                                disabled={activeSubscriptionCode.length > 0 && !isInTrial}
                                                                onKeyDown={(e) => {
                                                                    const nextValue = parseInt(e.target.value + e.key, 10);
                                                                    if (!isNaN(nextValue) && nextValue > 500) {
                                                                        e.preventDefault();
                                                                    }
                                                                }}
                                                            />
                                                            <div className="pt-2">Inserisci il numero dei dipendenti per calcolare il costo.</div>
                                                            <div>Per un numero di dipendenti maggiore di 500, contattaci</div>
                                                        </td>
                                                        {subscriptionPlansToRender.map((plan) => {
                                                            const { original, discounted, hasPackagePromoDiscount } = calculateTotalCost(plan);
                                                            const isCurrentPlan = activeSubscriptionCode?.includes(plan?.stripePlanId);

                                                            return (
                                                                <td key={plan.name} className="px-4 py-4 text-center border border-gray-200 text-indigo-800 font-semibold text-md">
                                                                    {profile.customer_type === 'consultant' ? (
                                                                        <>
                                                                            <div className="line-through text-gray-500">
                                                                                € {Number(original).toFixed(2)} / {duration === 'year' ? 'anno' : 'mese'} + IVA
                                                                            </div>
                                                                            <div className="flex items-center justify-center mt-2">
                                                                                <div className="bg-orange-50 text-orange-500 font-semibold rounded-full p-2 flex items-center justify-center w-14 h-14 mr-2">
                                                                                    -30%
                                                                                </div>
                                                                                <div className="text-indigo-800">
                                                                                    € {Number(discounted).toFixed(2)} / {duration === 'year' ? 'anno' : 'mese'} + IVA
                                                                                </div>
                                                                            </div>
                                                                        </>
                                                                    ) : (
                                                                        <>
                                                                            {hasPackagePromoDiscount ? (
                                                                                <>
                                                                                    <div className="text-gray-500 line-through">
                                                                                        € {Number(original).toFixed(2)} / {duration === 'year' ? 'anno' : 'mese'} + IVA
                                                                                    </div>
                                                                                    <div className="mt-1 text-indigo-800 font-bold">
                                                                                        € {Number(discounted).toFixed(2)} / {duration === 'year' ? 'anno' : 'mese'} + IVA
                                                                                    </div>
                                                                                </>
                                                                            ) : (
                                                                                <div>
                                                                                    € {Number(discounted).toFixed(2)} / {duration === 'year' ? 'anno' : 'mese'} + IVA
                                                                                </div>
                                                                            )}
                                                                        </>
                                                                    )}
                                                                    <div className="items-center text-center justify-center flex mt-3">
                                                                        {(activeSubscriptionCode && activeSubscriptionCode.length > 0 && !isInTrial) ? (
                                                                            isCurrentPlan ? (
                                                                                <span className="text-md font-medium text-gray-900">Questa è la tua sottoscrizione</span>
                                                                            ) : (
                                                                                <>
                                                                                    {hasCancelAtPeriodEndSubscription ? (
                                                                                        <CustomTooltipComponent
                                                                                            title="Non puoi aggiornare la sottoscrizione perché il rinnovo automatico è stato disattivato"
                                                                                            arrow
                                                                                            placement="top"
                                                                                        >
                                                                                            <span>
                                                                                            <button
                                                                                                className="bg-gray-400 text-white py-1 px-4 rounded cursor-not-allowed"
                                                                                                disabled
                                                                                            >
                                                                                                Aggiorna Sottoscrizione
                                                                                            </button>
                                                                                            </span>
                                                                                        </CustomTooltipComponent>
                                                                                    ) : (
                                                                                        <button
                                                                                            className="bg-indigo-600 hover:bg-indigo-500 text-white py-1 px-4 rounded"
                                                                                            onClick={() => handleUpgrade(plan, employeeCount, 'upgradeSubscription')}
                                                                                        >
                                                                                            Aggiorna Sottoscrizione
                                                                                        </button>
                                                                                    )}
                                                                                </>
                                                                            )
                                                                        ) : (
                                                                            <button
                                                                                className={`py-1 px-4 rounded text-white ${isCompany && !isProfileComplete ? 'bg-gray-400 cursor-not-allowed' : 'bg-indigo-600 hover:bg-indigo-500'}`}
                                                                                onClick={() => handleSelectLevel(plan, employeeCount, 'newSubscription')}
                                                                                disabled={isCompany && !isProfileComplete}
                                                                            >
                                                                                Scegli
                                                                            </button>
                                                                        )}
                                                                    </div>
                                                                    {(isCompany && !isProfileComplete) && (
                                                                        <div className="w-full">
                                                                            <div className="bg-orange-100 text-orange-600 p-4 mt-2 rounded-md">
                                                                                <p className="text-center text-sm font-semibold">
                                                                                Il profilo non è completo. <br />
                                                                                Per abilitare l'acquisto di un piano, compila i campi mancanti{' '}
                                                                                <Link
                                                                                    to="/profilo/fatturazione"
                                                                                    className="text-indigo-600 hover:text-indigo-800 underline"
                                                                                >
                                                                                    cliccando qui
                                                                                </Link>
                                                                                </p>
                                                                            </div>
                                                                        </div>
                                                                    )}
                                                                </td>
                                                            );
                                                        })}
                                                    </tr>
                                                </tbody>
                                            </table>
                                        </div>

                                        {/* Icona del piano Pro */}
                                        {subscriptionPlansToRender.map((plan) => (
                                            plan.name === 'Pro' && (
                                                <div
                                                    key={plan.name}
                                                    style={{
                                                        zIndex: '5',
                                                        position: 'absolute',
                                                        top: '-30px',
                                                        right: '-40px'
                                                    }}
                                                >
                                                    <SvgBestChoice />
                                                </div>
                                            )
                                        ))}
                                    </div>
                                </main>

                            )}
                        </div>
                    </div>
                )}
                <div className="align-bottom">
                    <Footer />
                </div>
            </div>


            {isModalOpen && (
                <ModalUpdateSubscription
                    mode={mode}
                    selectedPlan={selectedPlan}
                    employeeCount={employeeCount}
                    duration={duration}
                    selectedPrice={selectedPrice}
                    onClose={handleCloseModal}
                    token={token}
                    subscriptionIdtoUpgrade={subscriptionId}
                    planUpgrade={selectedPlanUpgrade}
                    onSubscriptionChanged={refreshBilling}
                    activeProSubscription={activeProSubscription}
                    activeBaseSubscription={activeBaseSubscription}
                    selectedPackages={selectedPackagesToCheckout}
                    customerType={profile.customer_type}
                />
            )}
        </>
    )
}

const SvgBestChoice = () => {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width="125"
            height="125"
            viewBox="200 200 410 410"
            preserveAspectRatio="xMidYMid meet"
            className="inline-block ml-2"
        >
            <defs>
                <clipPath id="clip-path-id">
                    <path d="M 284.917969 243 L 524.917969 243 L 524.917969 567 L 284.917969 567 Z" />
                </clipPath>
            </defs>
            <g clipPath="url(#clip-path-id)">
                <path
                    fill="#3730a3"
                    d="M 292.820312 345.964844 C 288.949219 351.261719 284.945312 356.742188 284.945312 363.054688 C 284.945312 369.371094 288.949219 374.851562 292.820312 380.148438 C 295.644531 384.015625 298.3125 387.667969 299.308594 391.382812 C 300.363281 395.320312 299.851562 400.167969 299.351562 404.859375 C 298.675781 411.257812 297.976562 417.871094 300.996094 423.09375 C 304.0625 428.398438 310.183594 431.113281 316.101562 433.738281 C 318.066406 434.605469 320.078125 435.507812 321.941406 436.484375 L 290.695312 534.839844 C 290.503906 535.449219 290.648438 536.113281 291.082031 536.582031 C 291.511719 537.050781 292.164062 537.253906 292.78125 537.113281 L 333.574219 527.855469 L 359.339844 566.230469 C 359.671875 566.726562 360.230469 567.015625 360.816406 567.015625 C 360.898438 567.015625 360.984375 567.011719 361.066406 567 C 361.742188 566.902344 362.304688 566.425781 362.511719 565.777344 L 390.667969 477.214844 C 395.417969 480.550781 399.917969 483.109375 404.996094 483.109375 C 410.125 483.109375 414.609375 480.546875 419.332031 477.207031 L 447.46875 565.777344 C 447.675781 566.425781 448.238281 566.902344 448.914062 567 C 448.996094 567.011719 449.082031 567.019531 449.164062 567.019531 C 449.75 567.019531 450.308594 566.726562 450.640625 566.230469 L 476.40625 527.859375 L 517.199219 537.113281 C 517.816406 537.253906 518.46875 537.050781 518.902344 536.582031 C 519.332031 536.113281 519.476562 535.449219 519.285156 534.84375 L 488.042969 436.488281 C 489.898438 435.511719 491.910156 434.609375 493.878906 433.738281 C 499.796875 431.113281 505.917969 428.398438 508.980469 423.097656 C 512 417.878906 511.304688 411.273438 510.632812 404.878906 C 510.136719 400.183594 509.628906 395.328125 510.6875 391.386719 C 510.6875 391.386719 510.6875 391.386719 510.6875 391.382812 C 511.679688 387.660156 514.347656 384.007812 517.171875 380.140625 C 521.039062 374.84375 525.035156 369.367188 525.035156 363.058594 C 525.035156 356.75 521.035156 351.273438 517.171875 345.976562 C 514.347656 342.109375 511.679688 338.457031 510.6875 334.730469 C 509.625 330.789062 510.136719 325.933594 510.632812 321.238281 C 511.304688 314.84375 512 308.234375 508.980469 303.019531 C 505.90625 297.707031 499.765625 294.992188 493.828125 292.363281 C 489.367188 290.390625 485.152344 288.527344 482.34375 285.71875 C 479.535156 282.902344 477.671875 278.691406 475.699219 274.230469 C 473.070312 268.296875 470.355469 262.15625 465.035156 259.078125 C 459.804688 256.058594 453.183594 256.753906 446.78125 257.421875 C 442.09375 257.914062 437.246094 258.421875 433.308594 257.371094 C 429.59375 256.378906 425.945312 253.710938 422.085938 250.886719 C 416.789062 247.007812 411.3125 243 405 243 C 398.691406 243 393.214844 247.003906 387.921875 250.875 C 384.050781 253.699219 380.398438 256.375 376.671875 257.367188 C 372.734375 258.417969 367.882812 257.910156 363.199219 257.417969 C 356.796875 256.746094 350.179688 256.050781 344.960938 259.074219 C 339.636719 262.148438 336.921875 268.289062 334.296875 274.21875 C 332.320312 278.679688 330.457031 282.894531 327.640625 285.710938 C 324.828125 288.523438 320.617188 290.382812 316.160156 292.359375 C 310.230469 294.984375 304.09375 297.703125 301.019531 303.015625 C 297.984375 308.238281 298.683594 314.859375 299.355469 321.265625 C 299.851562 325.953125 300.359375 330.792969 299.308594 334.726562 C 298.3125 338.449219 295.644531 342.097656 292.820312 345.964844 Z"
                />
            </g>
            <text
                x="98%"
                y="85%"
                textAnchor="middle"
                fill="#ffffff"
                fontWeight="bold"
                fontSize="25"
            >
                SCELTA PIÙ
            </text>
            <text
                x="98%"
                y="95%"
                textAnchor="middle"
                fill="#ffffff"
                fontWeight="bold"
                fontSize="25"
            >
                POPOLARE
            </text>
        </svg>
    );
};
